import { Directive, ElementRef, Input, OnInit, inject } from '@angular/core';
import { AuthService } from 'src/app/core/auth/auth.service';

@Directive({
  selector: '[rqaPermission]',
  standalone: true
})
export class PermissionDirective implements OnInit {
  @Input() rqaPermission: string | string[] = '';
  @Input() rqaPermissionMode: 'any' | 'all' = 'any';

  private elementRef = inject(ElementRef);
  private authService = inject(AuthService);

  ngOnInit() {
    this.checkPermission();
  }

  private checkPermission() {
    let hasPermission = false;

    if (typeof this.rqaPermission === 'string') {
      hasPermission = this.authService.hasRole(this.rqaPermission);
    } else if (Array.isArray(this.rqaPermission)) {
      if (this.rqaPermissionMode === 'all') {
        hasPermission = this.authService.hasAllRoles(this.rqaPermission);
      } else {
        hasPermission = this.authService.hasAnyRole(this.rqaPermission);
      }
    }

    if (!hasPermission) {
      this.elementRef.nativeElement.style.display = 'none';
    }
  }
}
